import React, { useState } from 'react';
import RunsList from './RunsList';
import ConfigureEmail from './configureEmail';

const ElectronicDeliveryRequestsPortalNotifications = () => {
  const [configureEmail, setConfigureEmail] = useState(false);

  return(
      <div>
        {
          configureEmail ?
            <ConfigureEmail
              setConfigureEmail={setConfigureEmail}
            /> :
            <RunsList
              setConfigureEmail={setConfigureEmail}
            />
        }
      </div>
    )
};

export default ElectronicDeliveryRequestsPortalNotifications;
